// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"crowdcast-widget_wrapper__jjZFV","frame":"crowdcast-widget_frame__O6hwh"};